<template>
   <nav class="panel" style="margin-top:2em;">
        <p class="panel-block">
            <strong>{{$t("timeStatus.balance")}}</strong>
        </p>
        <div class="panel-block">
            <span class="panel-icon">
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
            </span>
                <a v-on:click="showRegs = !showRegs">
                    <span class="icon">
                        <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!showRegs"></font-awesome-icon>
                        <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="showRegs"></font-awesome-icon>
                    </span>
                    {{$t("timeStatus.regs")}} 
                </a>
                <div class="tags">
                    <span class="tag is-success">{{$t("timeStatus.allRegs")}}&nbsp;{{ registeredTimeToDate }}</span>
                    <weekTimeSum :display-text="$t('timeStatus.currentWeek')" :all-registrations="allRegistrations" :personal-settings="personalSettings" :week-no="Number(currentWeek)"/> 
                </div>                                  
        </div>
        <div class="panel-block" v-if="showRegs">
            <!-- <regChart /> -->
            <span class="tag is-warning">{{$t("timeStatus.notApprovedHours")}} {{ notApprovedTimeToDate }}</span>
        </div>
        <div class="panel-block">
            <span class="panel-icon">
                <font-awesome-icon :icon="['far', 'calendar-check']" ></font-awesome-icon>
            </span>
            <a v-on:click="showFlex = !showFlex">
                <span class="icon">
                    <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!showFlex"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="showFlex"></font-awesome-icon>
                </span>
                Flex 
            </a>
            <div class="tags">
                <span class="tag is-primary" v-if="returnAvailabilityCommitment">{{$t("timeStatus.balanceMinusAvail")}} {{ calendar.methods.availabilityCommitment(returnAvailabilityCommitment, returnStartBalance, allRegistrations, workHours, dkHolidays, activeDate, today) }}</span>       
                <span class="tag is-primary" v-else>Saldo: {{ registeredTimeToDate - calendar.methods.noWorkingHours(workHours, dkHolidays, activeDate, today) + returnStartBalance }}</span>       
           </div>
        </div>
        <div class="panel-block" v-if="showFlex">
            <regChart :regs="allRegistrations" />
        </div>
        <div class="panel-block">
            <span class="panel-icon">
                <font-awesome-icon icon="plane-departure"></font-awesome-icon>
            </span>
            <a v-on:click="showVacation = !showVacation">
                <span class="icon">
                    <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!showVacation"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="showVacation"></font-awesome-icon>
                </span>
                Ferie 
            </a>
            <div class="tags">
                <span class="tag is-info" v-if="user && user.adminCanEdit && user.adminCanEdit.vacationStartBalance && activeDate && today && vacationRegistrations">{{$t("timeStatus.vacBalance")}} {{ calendar.methods.noVacationDaysLeft(activeDate, today, vacationRegistrations, user.adminCanEdit.vacationStartBalance) }}</span>
                <span class="tag is-info">{{$t("timeStatus.earnedVac")}} {{ calendar.methods.vacationDays(activeDate, today, isThereAStartDate) }}</span>
            </div>
        </div>
        <div class="panel-block" v-if="showVacation">
            <span class="tag is-info">{{$t("timeStatus.vacDays")}} {{ calendar.methods.noOfHolidays(dkHolidays, startOfYear, endOfYear) }}</span>
        </div>
    </nav>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

import regChart from '@/components/charts/regChart.vue'
import calendar from '../../utils/calendar'
import weekTimeSum from '../../utils/weekTimeSum.vue'

export default {
  name: 'TimeStatus',
  components: {
      regChart,
      weekTimeSum
  },
  data: function() {
      return {
          showRegs: false,
          showFlex: false,
          showVacation: false,
          today: moment().format(),
          activeDate: moment().startOf('year'),
          isThereAStartDate: false,
          startOfYear: moment().startOf('year'),
          endOfYear: moment().endOf('year'),
          currentWeek: moment().isoWeek()
      }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        allRegistrations: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + userid).orderByChild('date'),
            asObject: false
        },
        vacationRegistrations: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrationsAbsence/' + userid).orderByChild('absence').equalTo('FERIE'),
            asObject: false,
        },
        dkHolidays: {
            source: firebase.database().ref('/holidays/dk/' + this.currentYear),
        },
        personalSettings: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/settings'),
            asObject: true,
        },
        workHours: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/settings'),
            asObject: true
        },
        user: {
              source: firebase.database().ref('/organisations/' + tenantid + '/users/' + userid),
              asObject: true,
              readyCallback() {
                if(this.user && this.user.adminCanEdit.activeDate && moment(this.user.adminCanEdit.activeDate).isSameOrAfter(moment().startOf('year'), 'year')) {
                    this.activeDate = this.user.adminCanEdit.activeDate;
                    this.isThereAStartDate = true;
                } else {
                    this.activeDate = moment().startOf('year');
                    this.isThereAStartDate = false;
                }
              }
          },
    }
  },
  computed: {
    returnStartBalance() {
        if(this.user && this.user.adminCanEdit && this.user.adminCanEdit.startBalance) {
            return this.user.adminCanEdit.startBalance
        } else {
            return 0
        }
    },
    returnAvailabilityCommitment() {
        if(this.user && this.user.adminCanEdit && this.user.adminCanEdit.availabilityCommitment) {
            return true
        } else {
            return false
        }
    },
    currentYear() {
        return moment().year()
    },
    registeredTimeToDate() {
        return _.sumBy(this.allRegistrations, 'time') || 0
    },
    notApprovedTimeToDate() {
        return _.sumBy(_.filter(this.allRegistrations, {'isApproved': false}), 'time') || 0
    }
  },
  beforeCreate() {
    this.calendar = calendar
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tags {
   margin-left: 1em;
}
</style>
